import Icon from '../components/Icon';

const DifficultyEasy = Icon(
  'difficulty-easy',
  <>
    <circle cx="12" cy="12" r="8.25" />
  </>
);

export default DifficultyEasy;
